import React from 'react';
import PropTypes from 'prop-types';
import HubsEntityCollection from '../../../../../components/HubsEntityCollection';
import HubsSelectField from '../../../../../components/HubsSelectField';

export const EntityComponent = ({ entity, handleChange, order, collection, entityGroup }) => {
  const entityData = collection.editor.getEntity(entity.eid, 'he_qualification_type');
  return (
    <React.Fragment>
      <HubsSelectField
        selection
        field={entityData.getField('he_requiredoptrecommend')}
        initialValue={entity.value}
        name=""
        onChange={(e, value) => handleChange(e, {
          value: value.value,
          order,
          name: 'value',
        }, entityGroup, order)}
      />
    </React.Fragment>
  );
};

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
  entityGroup: PropTypes.string,
};

const ApplicationRequirements = ({ onChange, entityGroup, ...props }) => (
  <HubsEntityCollection
    {...props}
    entityGroup={entityGroup}
    disableRemove
    _key="he_qualification_type"
  >
    <EntityComponent handleChange={onChange} entityGroup={entityGroup} />
  </HubsEntityCollection>
);

ApplicationRequirements.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
  entityGroup: PropTypes.string,
};

export default ApplicationRequirements;
